const sanitizeLink = (link) => (link.endsWith('/') ? link : link + '/')

export const ROOT = '/'
export const INVALID_CREDENTIALS_HELP = ({ links: { support } }) =>
  `${sanitizeLink(support)}hc/en-us/articles/115005872146`
export const RECOVER_PASSWORD = '/users/password/recover'
export const AUTHENTICATE = '/authenticate'
export const LEARN_MORE_ABOUT_SECURITY_KEYS = ({ links: { support } }) =>
  `${sanitizeLink(support)}hc/en-us/articles/360020338552`
